var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert",
    clipPath: "url(#clip0_1232_23706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99967 1.33203C11.6817 1.33203 14.6663 4.3167 14.6663 7.9987C14.6663 11.6807 11.6817 14.6654 7.99967 14.6654C4.31767 14.6654 1.33301 11.6807 1.33301 7.9987C1.33301 4.3167 4.31767 1.33203 7.99967 1.33203ZM7.99967 9.9987C7.82286 9.9987 7.65329 10.0689 7.52827 10.194C7.40325 10.319 7.33301 10.4886 7.33301 10.6654C7.33301 10.8422 7.40325 11.0117 7.52827 11.1368C7.65329 11.2618 7.82286 11.332 7.99967 11.332C8.17649 11.332 8.34606 11.2618 8.47108 11.1368C8.5961 11.0117 8.66634 10.8422 8.66634 10.6654C8.66634 10.4886 8.5961 10.319 8.47108 10.194C8.34606 10.0689 8.17649 9.9987 7.99967 9.9987ZM7.99967 3.9987C7.83639 3.99872 7.67878 4.05867 7.55676 4.16717C7.43474 4.27568 7.35678 4.4252 7.33767 4.58736L7.33301 4.66536V8.66536C7.3332 8.83528 7.39826 8.99872 7.51491 9.12228C7.63155 9.24583 7.79098 9.32019 7.9606 9.33015C8.13023 9.3401 8.29726 9.28492 8.42756 9.17586C8.55787 9.06679 8.64161 8.9121 8.66167 8.74336L8.66634 8.66536V4.66536C8.66634 4.48855 8.5961 4.31898 8.47108 4.19396C8.34606 4.06894 8.17649 3.9987 7.99967 3.9987Z",
    fill: "#FFA7A1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_23706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.5993916a69918b27da44cd4e6d38af53.svg";
export { ForwardRef as ReactComponent };